export enum UserTypeContextEnum {
  USER = 'USER',
  OWNER = 'OWNER',
}
